class WPAdditionalProducts extends HTMLElement {
  connectedCallback() {
    try {
      const root = this;
      const items = Array.from(root.querySelectorAll('.additional-products__item'));
      if (!items.length) return;

      const moneyFormatStr = root.dataset.moneyFormat || "$0.00";
      const formatMoney = (cents) => {
        try {
          if (window.Shopify && typeof Shopify.formatMoney === 'function') {
            return Shopify.formatMoney(Math.round(cents), moneyFormatStr);
          }
        } catch (e) { /* noop */ }
        return `$${(Math.round(cents) / 100).toFixed(2)}`;
      };

      const totalEl = root.querySelector('[data-ap-total]');

      const updateItemPrice = (li) => {
        try {
          const priceNow = li.querySelector('.ap-item__price .ap-price__now');
          const priceWas = li.querySelector('.ap-item__price .ap-price__was');
          const variantSel = li.querySelector('.ap-item__variant');
          if (!variantSel || !priceNow) return;
          const opt = variantSel.tagName === 'SELECT' ? variantSel.selectedOptions[0] : variantSel;
          const dollars = parseFloat(opt?.dataset?.price || '0');
          const cents = Math.round(dollars * 100);
          priceNow.textContent = `+${formatMoney(cents)}`;
          if (priceWas && (!priceWas.textContent || priceWas.textContent.trim() === '')) {
            priceWas.style.display = 'none';
          }
        } catch (e) { /* noop */ }
      };

      const getItemPrice = (li) => {
        const variantSel = li.querySelector('.ap-item__variant');
        let qty = 1;
        let price = 0;
        if (variantSel) { 
          const opt = variantSel.tagName === 'SELECT' ? variantSel.selectedOptions[0] : variantSel;
          price = parseFloat(opt?.dataset?.price || '0') * 100; // to cents
          qty = parseInt(opt?.dataset?.qty || '1', 10);
        }
        return price * qty;
      };

      const recalc = () => {
        const sum = items.reduce((acc, li) => {
          const checked = li.querySelector('.ap-item__check')?.checked;
          return checked ? acc + getItemPrice(li) : acc;
        }, 0);
        if (totalEl) totalEl.textContent = formatMoney(sum);
      };

      root.addEventListener('change', (e) => {
        if (e.target.matches('.ap-item__check,.ap-item__qty-select,.ap-item__variant')) {
          if (e.target.matches('.ap-item__variant')) {
            const li = e.target.closest('.additional-products__item');
            if (li) updateItemPrice(li);
          }
          recalc();
        }
      });

      // initialize prices and total
      items.forEach(updateItemPrice);
      recalc();

      const cta = root.querySelector('[data-ap-add]');
      if (cta) {
        let submitting = false;
        cta.addEventListener('click', async (e) => {
          // prevent default and block multiple clicks
          if (e) e.preventDefault();
          if (submitting) return;
          submitting = true;

          // show spinner and disable
          const originalHtml = cta.innerHTML;
          cta.setAttribute('disabled', 'disabled');
          cta.setAttribute('aria-busy', 'true');
          cta.classList.add('is-loading');
          cta.innerHTML = '<span class="ap-spinner" style="display:inline-block;width:16px;height:16px;border:2px solid rgba(255,255,255,.6);border-top-color:#fff;border-radius:50%;margin-right:8px;vertical-align:middle;animation:apspin 1s linear infinite"></span><span>Adding…</span>';

          // inject keyframes once (idempotent)
          if (!document.getElementById('apspinner-style')) {
            const style = document.createElement('style');
            style.id = 'apspinner-style';
            style.textContent = '@keyframes apspin{to{transform:rotate(360deg)}}';
            document.head.appendChild(style);
          }

          console.log('click additional open');
          const payload = { items: [] };
          items.forEach((li) => {
            const checked = li.querySelector('.ap-item__check')?.checked;
            if (!checked) return;
            const variantEl = li.querySelector('.ap-item__variant');
            if (!variantEl) return;
            const id = variantEl.tagName === 'SELECT' ? variantEl.value : variantEl.value;
            const opt = variantEl.tagName === 'SELECT' ? variantEl.selectedOptions[0] : variantEl;
            const quantity = parseInt(opt?.dataset?.qty || '1', 10);
            const sellingPlanId = opt?.dataset?.sellingPlanId;
            if (id) {
              const item = { id: Number(id), quantity };
              if (sellingPlanId) item.selling_plan = sellingPlanId;
              payload.items.push(item);
            }
          });
          if (payload.items.length === 0) return;
          try {
            console.log('payload', payload);
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(payload)
            });
            if (!res.ok) throw new Error('Add to cart failed');
            
          } catch (err) { console.error(err); }
          finally {
            // restore button
            cta.innerHTML = originalHtml;
            cta.removeAttribute('disabled');
            cta.removeAttribute('aria-busy');
            cta.classList.remove('is-loading');
            submitting = false;
            theme.Header.openCartDrawer();
         //   window.location.href = '/cart';
          }
        });
      }
    } catch (e) {
      console.error('WPAdditionalProducts init error', e);
    }
  }
}

customElements.define('wp-additional-products', WPAdditionalProducts);
